import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { NAVIGATIONS_UBI, NAVIGATIONS_UBI_NO_UTIL} from './navigation';
import { AdminAuthService } from './admin-auth.service';
import { environment as ENV } from 'environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'wl-admin',
  templateUrl: './admin.component.html',
  // encapsulation: ViewEncapsulation.None,
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  watcher: Subscription;
  activeMediaQuery = '';
  sideNav = { mode: 'side', isOpened: true };
  toggle: boolean;
  navList: any;
  cName: String;
  isLoggingOut = false;
  demo: any;

  roleId: any;
  role: string;
  userName: string;
  event$: any;
  currUrl: string;
  userRoleId: string;
  level: any;
  showChangePassword: boolean;
  // breakpointObserver: any;

  constructor(
    private router: Router,
    private adminAuth: AdminAuthService,
    private breakpointObserver: BreakpointObserver,
    private snackbar: MatSnackBar
  ) {
    this.event$ = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currUrl = this.router.url || '';
        console.log('printevent', this.currUrl);
        this.showChangePassword = this.currUrl === '/admin/landing1' ? false : true;
      }
    });
  
    this.roleId = sessionStorage.getItem('getroleId');
    this.userName = sessionStorage.getItem('userName');
  
    this.navList = ENV.creditScoreSetting.credMenu === 'ubi' && [8, 7, 0, 11, 12].includes(this.roleId)
      ? NAVIGATIONS_UBI
      : NAVIGATIONS_UBI_NO_UTIL;
  
    switch (ENV.placeHolderSetting.demo) {
      default:
        this.demo = ENV.placeHolderSetting.demo;
        break;
    }
  
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
    ]).subscribe(result => {
      this.sideNav = result.matches
        ? { mode: 'push', isOpened: false }
        : { mode: 'side', isOpened: true };
    });
  }
  

  ngOnInit() {
    this.changeColor(0)
    this.userName = sessionStorage.getItem('userName')
    this.userRoleId = sessionStorage.getItem('getroleId');
    if(this.userRoleId == '1'){
      this.level = 'Central Office'
    }else if(this.userRoleId == '2'){
      this.level = 'Zonal Admin'
    }else if(this.userRoleId == '3'){
      this.level = 'Regional Admin'
    }else if(this.userRoleId == '4'){
      this.level = 'Branch Admin'
    }else if(this.userRoleId == '5'){
      this.level = 'RDO'
    }else if(this.userRoleId == '11'){
      this.level = 'Maker'
    }else if(this.userRoleId == '12'){
      this.level = 'Checker'
    }else if(this.userRoleId == '21'){
      this.level = 'Zone User'
    }else if(this.userRoleId == '31'){
      this.level = 'Regional User'
    }else if(this.userRoleId == '41'){
      this.level = 'Branch User'
    }else if(this.userRoleId == '0'){
      this.level = 'Super Admin'
    }

  }

  toggleSubmenu(menuItem) {
    menuItem.isSubmenuVisible = !menuItem.isSubmenuVisible;
    if (menuItem.link) {
      this.router.navigate([menuItem.link]);
    }
  }

  adminLogout() {
    const userId = sessionStorage.getItem('wl-admin-id');
    if (!userId) {
      this.snackbar.open('Failed to logout. User session not found.', 'OK', { duration: 3000 });
      return;
    }
    this.isLoggingOut = true;
    this.adminAuth.logoutFromServer(userId).subscribe(
      () => {
        this.adminAuth.adminLogout();
        setTimeout(() => {
          this.router.navigate(['/login-admin']);
        }, 2000);
      },
      (err) => {
        console.error('Logout API failed:', err);
        this.isLoggingOut = false;
        this.snackbar.open('Failed to logout. Please try again.', 'OK', { duration: 3000 });
      }
    );
  }

  changeColor(i){
    for(let i = 0; i<this.navList.length; i++){
      this.navList[i].isSelected = false
    }
    for(let i = 0; i<this.navList.length; i++){
      if(this.navList && this.navList[i] && this.navList[i].submenu){
        for(let m = 0; m<this.navList[i].submenu.length; m++){
          this.navList[i].submenu[m].isSubMenuSelected = false
        }
      }

    }
    this.navList[i].isSelected = true
  }

  changeColorSubMenu(k,j){
    for(let i = 0; i<this.navList.length; i++){
      this.navList[i].isSelected = false
    }
    for(let i = 0; i<this.navList.length; i++){
      if(this.navList && this.navList[i] && this.navList[i].submenu){
        for(let m = 0; m<this.navList[i].submenu.length; m++){
          this.navList[i].submenu[m].isSubMenuSelected = false
        }
      }

    }

    this.navList[k].submenu[j].isSubMenuSelected = true
  }

  toggleNav(){
    this.sideNav.isOpened =  !this.sideNav.isOpened
  }

  isSubMenuVisible() {
    if (this.roleId === '1' && this.currUrl === `/admin/utilities`) {
      return false;
    }
    if (this.roleId === '3' && (this.currUrl === `/admin/sof` || this.currUrl === `/fresh-app/sof`)) {
      return false;
    }
    return true
  }

  ngOnDestroy() {
    // unsubscribe to avoid memory leaks
    this.event$.unsubscribe();
  } 

}
